import { render, staticRenderFns } from "./_ProgramPagesDatabaseTable.vue?vue&type=template&id=673a6152"
import script from "./_ProgramPagesDatabaseTable.vue?vue&type=script&lang=js"
export * from "./_ProgramPagesDatabaseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports